import React from 'react';
interface ICard {
  key?: number;
  svgIcon: React.ReactNode;
  title: string;
  total: string;
  goTo?: any;
}

const RollUpStats: React.FC<ICard> = ({ key, svgIcon, title, total, goTo }) => {
  return (
    <div className='card-db-none' onClick={goTo} key={key}>
      <div className='card-db-header'>
        <div className='card-db-icon'>{svgIcon}</div>
        <div className='card-db-title'>{title}</div>
      </div>
      <div className='card-db-meta' style={{ marginBottom: '0px' }}>
        <span className='card-db-meta-span-info'>{total}</span>
      </div>
    </div>
  );
};
export default RollUpStats;
